'use client';

import React from 'react';
import { Select, Option } from 'src/components/PulseUI';
import { useProfile } from 'src/context/providers/ProfileProvider';

export type EducationType =
  | 'Residency'
  | 'Fellowship'
  | 'Internship'
  | 'Medical School';

interface EducationToggleProps {
  selectedOption: EducationType;
  setSelectedOption: (value: EducationType) => void;
}

const MENU_ITEMS: { value: EducationType; label: string }[] = [
  { value: 'Residency', label: 'Residency' },
  { value: 'Fellowship', label: 'Fellowship' },
  { value: 'Internship', label: 'Internship' },
  { value: 'Medical School', label: 'Medical School' },
];

const EducationToggle = ({
  selectedOption,
  setSelectedOption,
}: EducationToggleProps) => {
  const { details } = useProfile();

  const handleSelectionChange = (
    _event: React.MouseEvent,
    newValue: string | number
  ) => {
    setSelectedOption(newValue as EducationType);
  };

  return (
    <div className="flex flex-col gap-1" data-testid="education-selector-container">
      <div
        className="text-sm text-primary font-semibold leading-tight"
        id="education-label"
      >
        Providers who completed:
      </div>
      <div className="flex items-center gap-2">
        <Select
          id="education-selector"
          aria-labelledby="education-label"
          value={selectedOption}
          onChange={handleSelectionChange}
          className="min-w-60"
        >
          {MENU_ITEMS.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
        <div className="text-base text-primary leading-tight">
          within 4 years of {details?.name}
        </div>
      </div>
    </div>
  );
};

export default EducationToggle;
